/* unplugin-vue-components disabled */import { render } from "./BaseSpeachCard.vue?vue&type=template&id=f91db406&scoped=true&ts=true"
import script from "./BaseSpeachCard.vue?vue&type=script&lang=ts"
export * from "./BaseSpeachCard.vue?vue&type=script&lang=ts"

import "./BaseSpeachCard.vue?vue&type=style&index=0&id=f91db406&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91db406"]])

export default __exports__